import { db } from '../firebase-config';
import { collection, query, where, getDocs, orderBy } from 'firebase/firestore';

class TimesheetBlockingService {
  constructor() {
    this.reminderTimesheet = null;
    this.hasReminder = false;
  }

  // Vérifier s'il y a un rappel pour une feuille mensuelle non signée
  async checkMonthlyTimesheet(userEmail) {
    try {
      if (!userEmail) return null;

      console.log('🔍 Vérification des feuilles de temps mensuelles...');

      // Récupérer toutes les feuilles de temps mensuelles non signées
      const timesheetQuery = query(
        collection(db, "workSessionsMonth"),
        where("employeeEmail", "==", userEmail),
        where("status", "==", "En attente de signature salarié"),
        where("signed", "==", false),
        orderBy("monthStart", "asc")
      );

      const snapshot = await getDocs(timesheetQuery);
      const timesheets = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // Calculer la date limite de rappel (6 jours après validation admin)
      const now = new Date();
      const sixDaysAgo = new Date(now);
      sixDaysAgo.setDate(now.getDate() - 6);
      sixDaysAgo.setHours(23, 59, 59, 999);

      console.log('Date limite rappel (6 jours):', sixDaysAgo.toISOString());

      // Trouver les feuilles nécessitant un rappel
      let reminderTimesheet = null;
      
      for (const timesheet of timesheets) {
        // Ignorer les feuilles débloquées par l'admin
        if (timesheet.debloque) {
          console.log(`Feuille ${timesheet.monthName} ${timesheet.year} débloquée par l'admin`);
          continue;
        }

        const adminValidatedAt = timesheet.adminValidatedAt;
        if (!adminValidatedAt) continue;

        // Convertir en Date si c'est un Timestamp Firestore
        const validationDate = adminValidatedAt.toDate ? adminValidatedAt.toDate() : new Date(adminValidatedAt);
        
        console.log(`Feuille ${timesheet.monthName} ${timesheet.year} validée le:`, validationDate.toISOString());
        
        // Vérifier le rappel (6 jours)
        if (validationDate < sixDaysAgo) {
          reminderTimesheet = timesheet;
          console.log('⚠️ Feuille avec rappel trouvée:', timesheet.monthName, timesheet.year);
          break; // On prend la plus ancienne
        }
      }

      // Mettre à jour l'état
      this.reminderTimesheet = reminderTimesheet;
      this.hasReminder = !!reminderTimesheet;

      if (reminderTimesheet) {
        console.log('⚠️ Feuille avec rappel:', reminderTimesheet.monthName, reminderTimesheet.year);
      } else {
        console.log('✅ Aucune feuille nécessitant un rappel');
      }

      return {
        reminderTimesheet,
        hasReminder: this.hasReminder,
        isBlocked: false // Plus de blocage dans le système mensuel
      };

    } catch (error) {
      console.error('Erreur lors de la vérification du blocage:', error);
      return null;
    }
  }

  // Obtenir l'état actuel des rappels (sans blocage)
  getBlockingStatus() {
    return {
      isBlocked: false, // Plus de blocage
      hasReminder: this.hasReminder,
      blockedTimesheet: null, // Plus de blocage
      reminderTimesheet: this.reminderTimesheet
    };
  }

  // Réinitialiser l'état
  resetBlockingStatus() {
    this.reminderTimesheet = null;
    this.hasReminder = false;
  }

  // Formater le message de rappel
  getReminderMessage() {
    if (!this.reminderTimesheet) return '';

    const monthName = this.reminderTimesheet.monthName;
    const year = this.reminderTimesheet.year;

    return `Rappel : Votre feuille de temps de ${monthName} ${year} doit être signée. Sans signature, votre salaire ne pourra pas être versé.`;
  }
}

// Instance singleton
export const timesheetBlockingService = new TimesheetBlockingService();